var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingViewReportRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reporting_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: 0.62,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "reporting_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.55.93a16.94,16.94,0,0,0-16.93,17V430.76a17,17,0,0,0,16.93,17H582.62a17,17,0,0,0,16.94-17V17.89a17,17,0,0,0-16.94-17",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.14,
    y: 77.45,
    width: 378.94,
    height: 446.79,
    rx: 16.79,
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.38,270.85V584.13a17,17,0,0,1-17.16,16.8H19.61a17,17,0,0,1-17.17-16.8V170.94a17,17,0,0,1,17.17-16.8H262.13a17.57,17.57,0,0,1,5.82,1L379.84,263.89A16.41,16.41,0,0,1,381.38,270.85Z",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14,264.5H285.59a17.21,17.21,0,0,1-17.35-17V155.74Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.08,
    y: 373.51,
    width: 260.86,
    height: 36.46,
    rx: 12,
    transform: "translate(-2.98 1.45) rotate(-0.44)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.19,
    y: 519.81,
    width: 133.04,
    height: 36.46,
    rx: 12,
    transform: "translate(-4.1 0.97) rotate(-0.44)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.52,
    y: 300.6,
    width: 260.86,
    height: 36.46,
    rx: 12,
    transform: "translate(-2.43 1.44) rotate(-0.44)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.63,
    y: 446.42,
    width: 260.1,
    height: 36.46,
    rx: 12,
    transform: "translate(-3.54 1.45) rotate(-0.44)",
    fill: "#b2b2b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingViewReportRequests);
export default __webpack_public_path__ + "static/media/reporting_view_report_requests.d8a2bc484dad8ba68bf80610a5c923b5.svg";
export { ForwardRef as ReactComponent };